import { ModalCustom } from "components/ModalCustom";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { useEffect, useState } from "react";
import {
  ContainerCheckbox,
  ContainerDropdown,
  DadosPlanilha,
  DadosPlanilhaInfo,
  DadosPlanilhaTitulo,
} from "./style";
import { useIntegracaoFipe } from "hooks/useIntegracaoFipe";

interface IProps {
  setDadosTabela: (dadosTabela: any) => void;
  dadosTabela: any;
  chassi: string;
  show: boolean;
  handleClose: () => void;
  setShow: (show: boolean) => void;
}

export function ModalEscolherMarcaModelo({
  setDadosTabela,
  dadosTabela,
  chassi,
  show,
  handleClose,
  setShow,
}: IProps) {
  const [marcaModeloSelecionado, setMarcaModeloSelecionado] =
    useState<string>("");
  const [marcaModeloPlanilha, setMarcaModeloPlanilha] = useState<string>("");
  const [placaSelecionada, setPlacaSelecionada] = useState<string>("");
  const [aplicarTodos, setAplicarTodos] = useState<boolean>(false);
  const { buscarMarcasPorTipoVeiculo, optionsMarcaModelo } =
    useIntegracaoFipe();
  const [tipoVeiculoSelecionado, setTipoVeiculoSelecionado] = useState<
    string | null
  >(null);
  const [sugestoes, setSugestoes] = useState<
    { nome: string; pontuacao: number }[]
  >([]);
  const [sugestaoEscolhida, setSugestaoEscolhida] = useState<string | null>(
    null
  );

  const onConfirm = () => {
    const novosDados = dadosTabela.map((dado: any) => {
      if (
        dado.veiculo.chassi === chassi ||
        (aplicarTodos &&
          !dado.veiculo.marcaModelo &&
          tipoVeiculoSelecionado &&
          dado.veiculo.tipo === tipoVeiculoSelecionado)
      ) {
        return {
          ...dado,
          veiculo: {
            ...dado.veiculo,
            marcaModelo: marcaModeloSelecionado,
          },
        };
      }
      return dado;
    });
    setShow(false);
    setDadosTabela(novosDados);
    setAplicarTodos(false);
  };

  useEffect(() => {
    const dadosVeiculo = dadosTabela.filter(
      (dado: any) => dado.veiculo.chassi === chassi
    );

    setSugestaoEscolhida(null);

    if (dadosVeiculo.length) {
      buscarMarcasPorTipoVeiculo(dadosVeiculo[0].veiculo.tipo);
      setTipoVeiculoSelecionado(dadosVeiculo[0].veiculo.tipo);
      setMarcaModeloSelecionado(dadosVeiculo[0].veiculo.marcaModelo ?? "");
      setMarcaModeloPlanilha(dadosVeiculo[0].veiculo.marcaModeloPlanilha ?? "");
      setPlacaSelecionada(dadosVeiculo[0].veiculo.placa ?? "");
      setSugestoes(dadosVeiculo[0].veiculo.sugestoesMarcaModelo ?? []);
      return;
    }

    setTipoVeiculoSelecionado(null);
    setSugestoes([]);
    setMarcaModeloSelecionado("");
    setPlacaSelecionada("");
    setMarcaModeloPlanilha("");
  }, [show]);

  const handleEscolherSugestao = (index: number, sugestaoMarcada: string) => {
    setMarcaModeloSelecionado(sugestaoMarcada);
    setSugestaoEscolhida(`sugestao${index}`);
  };

  return (
    <ModalCustom
      handleClose={handleClose}
      show={show}
      title="Escolher marca/modelo"
      footer
      footerConfirmButton
      onConfirm={onConfirm}
      centered
      size="lg"
    >
      <ContainerDropdown>
        <DadosPlanilha>
          <DadosPlanilhaTitulo>Dados da planilha</DadosPlanilhaTitulo>
          <DadosPlanilhaInfo>
            Marca/Modelo:{" "}
            {marcaModeloPlanilha.length ? marcaModeloPlanilha : "--"}
          </DadosPlanilhaInfo>
          <DadosPlanilhaInfo>
            Placa: {placaSelecionada.length ? placaSelecionada : "--"}
          </DadosPlanilhaInfo>
          <DadosPlanilhaInfo>Chassi: {chassi ?? "--"}</DadosPlanilhaInfo>
        </DadosPlanilha>
        <div style={{ marginBottom: 4 }}>
          Escolha a marca/modelo na listagem abaixo
          {!!sugestoes.length ? " ou selecione uma das opções sugeridas:" : ":"}
        </div>
        <DropdownSelect
          searchable
          onSelect={(value) => {
            setMarcaModeloSelecionado(value);
          }}
          options={tipoVeiculoSelecionado ? optionsMarcaModelo : []}
          selectedValue={marcaModeloSelecionado}
          required
        />
      </ContainerDropdown>

      {!!sugestoes.length ? (
        <div style={{ marginTop: 12 }}>
          <div style={{ marginBottom: 4 }}>Sugestões de modelo:</div>
          {sugestoes.map(
            (sugestao: { nome: string; pontuacao: number }, index) => {
              return (
                <div style={{ marginLeft: 12 }}>
                  {" "}
                  <input
                    onChange={(e) =>
                      handleEscolherSugestao(index, sugestao.nome)
                    }
                    type="checkbox"
                    checked={
                      marcaModeloSelecionado === sugestao.nome ||
                      sugestaoEscolhida === `sugestao${index}`
                    }
                  />
                  <label
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      marginLeft: 8,
                    }}
                  >
                    {sugestao.nome}
                  </label>
                </div>
              );
            }
          )}
          <hr></hr>
        </div>
      ) : (
        ""
      )}
      <ContainerCheckbox>
        <input
          onChange={(e) => setAplicarTodos(e.target.checked)}
          type="checkbox"
          checked={aplicarTodos}
        />
        <label
          style={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "100%",
            letterSpacing: "0%",
            marginLeft: 8,
          }}
        >
          Aplicar o modelo escolhido para todos os veículos sem marca/modelo que
          tenham o mesmo tipo
        </label>
      </ContainerCheckbox>
    </ModalCustom>
  );
}
